import { cloneDeep } from "lodash";

export const setSurveySmsNotifications = ({ notifications, sms }) => {
  notifications.sms = sms;

  return cloneDeep(notifications);
};

export default setSurveySmsNotifications;
